import type { PublicPlanDefinition } from '../types/platformOrganization';

function formatLimit(value: number | null | undefined, suffix = '') {
  if (value == null) return 'Ilimitado';
  return `${value}${suffix}`;
}

export function buildPlanFeatureList(plan: PublicPlanDefinition): string[] {
  const items = [
    `${formatLimit(plan.limits.maxTenants)} funerarias`,
    `${formatLimit(plan.limits.maxUsers)} usuarios`,
    `${formatLimit(plan.limits.maxActiveClients)} clientes`,
    `${formatLimit(plan.limits.maxServicesPerMonth)} servicios/mes`,
    `${plan.limits.storageGb ?? '—'} GB almacenamiento`,
  ];
  if (plan.features.advancedReports) items.push('Reportes avanzados + exportación');
  if (plan.features.emailAutomation) items.push('Correos automáticos');
  if (plan.features.auditLog) {
    items.push(
      plan.features.auditRetentionDays
        ? `Auditoría (${plan.features.auditRetentionDays} días)`
        : 'Auditoría completa'
    );
  }
  if (plan.features.apiAccess) items.push('API e integraciones');
  return items;
}
